import { useAuthStore } from '../../store/modules/auth';
import request from '../request.js';

/**
 * 发送短信验证码API
 * @param mobile 手机号码
 * @param countryCode 国家代码（默认：86）
 * @returns 发送结果
 */
export const sendSmsCode = async (mobile, countryCode = '86') => {
  try {
    const result = await request.post('/client/tender/sms/sendKaptcha', {
      mobile,
      countryCode
    }, {
      retry: 1,
      showSuccessMessage: true,
    });
    
    return result;
  } catch (error) {
    console.error('发送验证码失败:', error);
    throw error;
  }
};

/**
 * 短信登录API
 * @param data 登录数据（mobile, smsCaptcha, inviteId, countryCode）
 * @returns 登录结果
 */
export const smsLoginApi = async (data) => {
  try {
    const result = await request.post('/client/login/mobile', data, {
      retry: 1,
      showSuccessMessage: true,
    });
    return result;
  } catch (error) {
    console.error('短信登录失败:', error);
    throw error;
  }
};

/**
 * 账号登录API
 * @param data 登录数据
 * @returns 登录结果
 */
export const accountLogin = async (data) => {
  try {
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    
    const result = await request.post('/client/login/account', formData, {
      retry: 1,
      showSuccessMessage: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return result;
  } catch (error) {
    console.error('短信登录失败:', error);
    throw error;
  }
};

/**
 * 修改密码API
 * @param data 修改密码数据（tableId, password, newPassword）
 * @returns 修改结果
 */
export const changePassword = async (data) => {
  try {
    const store = useAuthStore();
    const formData = new FormData();
    formData.append('tableId', store.userInfo?.id);
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
    
    const result = await request.post('/login/v1/changePassword', formData, {
      retry: 1,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return result;
  } catch (error) {
    console.error('修改密码失败:', error);
    throw error;
  }
};
